import React, { useEffect, useState } from 'react'
import OnlineFriend from '../../components/onlinefriend/OnlineFriend'

const FriendRow = ({friend}) => {

      const [sprite, setSprite] = useState(false)
      const [imgSize, setImgSize] = useState([])

      const is_sprite = (obj) => {
            if(obj.width % obj.height === 0 && obj.height === 80){
                  setSprite(true)
            }else{
                  setSprite(false)
            }
      }

      const get_image_size = (src) => {
            var imgObj = {}
            const img = new Image() 
            img.onload = () => {
                  imgObj.width = img.naturalWidth 
                  imgObj.height = img.naturalHeight 
                  imgObj.steps = (img.naturalWidth / img.naturalHeight) - 1 
                  imgObj.time = (img.naturalWidth / img.naturalHeight) / 10 
                  setImgSize(imgObj)
            }

            /*img.onerror = () => {
                  throw new Error('invalid image')
            }*/

            img.src = src
      }

      useEffect(() => {
            get_image_size(friend.avatar)
      }, [friend.avatar])

      useEffect(() => {
            if(imgSize.length !== 0){
                  is_sprite(imgSize)
            }
      }, [imgSize])

      if(imgSize.length === 0) return 

      const style = {
            backgroundImage: `url(${friend.avatar})`,
            backgroundPosition: 'left top',
            animation: `move_img ${imgSize.time}s steps(${imgSize.steps}) infinite`
      }

      return (
            <div className="friend_row flex">
                  <div className="friend_row__avatar">
                        {
                              sprite 
                              ? <div className="friend_row__avatar_img gif" style={style}></div>
                              : <div className="friend_row__avatar_img img"><img src={friend.avatar} alt={friend.name} /></div>
                        }
                        
                        <OnlineFriend id={friend.id_xat} />
                  </div>
                  <div className="friend_row__data flex">
                        <div className="friend_row__data_info">
                              <span>{friend.name}</span>
                              <p>{friend.description}</p>
                        </div>
                        <a href={friend.me} className="btn_friend__row flex" target="_blank" rel="noreferrer">
                              xat.me
                        </a>
                  </div>
            </div>
      )
}

export default FriendRow
